import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion"
import one from "../images/1.png";

const Page1 = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/input");
  };

  const secondpage = () => {
    navigate("/page2", { state: { binaryInputValue, inputValue } });
  };

  const location = useLocation();
  const inputValue = location.state.inputValue;
  let dupInputValue = inputValue;
  let hexInputValue = "";
  let binaryInputValue = "";

  if (dupInputValue.length < 8) {
    while (dupInputValue.length < 8) {
      dupInputValue += "\0";
    }
  }

  for (let i = 0; i < dupInputValue.length; i++) {
    const hex = dupInputValue
      .charCodeAt(i)
      .toString(16)
      .toUpperCase()
      .concat(",");
    const bin = dupInputValue.charCodeAt(i).toString(2).concat(",");
    hexInputValue += hex.padStart(2, "0");
    hexInputValue = hexInputValue.split(",");
    binaryInputValue += bin.padStart(9, "0");
    binaryInputValue = binaryInputValue.split(",");
  }

  binaryInputValue.pop();
  hexInputValue.pop();

  let binaryInputValue56 = "";
  for (let i = 0; i < binaryInputValue.length; i++) {
    console.log(binaryInputValue[i].slice(0, 7));
    binaryInputValue56 += binaryInputValue[i].slice(0, 7) + ",";
  }
  binaryInputValue56 = binaryInputValue56.split(",");
  binaryInputValue56.pop();

  console.log(binaryInputValue);
  console.log(binaryInputValue56);

  // Function to highlight differing bits in binary strings
  const highlightDifferingBits = (binary1, binary2) => {
    const differingBits = [];
    for (let i = 0; i < binary1.length; i++) {
      if (binary1[i] !== binary2[i]) {
        differingBits.push(
          <span key={i} style={{ color: "red" }}>
            {binary1[i]}
          </span>
        );
      } else {
        differingBits.push(binary1[i]);
      }
    }
    return differingBits;
  };

  const icon = {
    hidden: {
      x: -700
    },
    visible: {
      x: 0,
      transition: {
        delay: 0.25,
        duration: 1
      }
    }
  }

  const variantsFor56Bit = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        delay: 1.25
      }
    }
  }

  return (
    <>
    <div className="content-box">
      <h3 className="head">What is done in this page?</h3>
      <p>In this page, the 64 bit key is transformed into a 56 bit key by discarding every 8th bit of the initial key. This is known
        as key transformation.<br></br><br></br>
        Given below, the bits in red are discarded.
      </p>
    </div>  
      <div className="input-container">
        <div className="flex flex-col items-center">
          <div className="flex flex-row">
            <div className="flex flex-col">
              <p>64 bit binary Value: </p>
              <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
                {highlightDifferingBits(
                  binaryInputValue[0],
                  binaryInputValue56[0]
                )}
                <br />
                {highlightDifferingBits(
                  binaryInputValue[1],
                  binaryInputValue56[1]
                )}
                <br />
                {highlightDifferingBits(
                  binaryInputValue[2],
                  binaryInputValue56[2]
                )}
                <br />
                {highlightDifferingBits(
                  binaryInputValue[3],
                  binaryInputValue56[3]
                )}
                <br />
                {highlightDifferingBits(
                  binaryInputValue[4],
                  binaryInputValue56[4]
                )}
                <br />
                {highlightDifferingBits(
                  binaryInputValue[5],
                  binaryInputValue56[5]
                )}
                <br />
                {highlightDifferingBits(
                  binaryInputValue[6],
                  binaryInputValue56[6]
                )}
                <br />
                {highlightDifferingBits(
                  binaryInputValue[7],
                  binaryInputValue56[7]
                )}
                <br />
              </div>
            </div>
            <div className="px-5">
              <p className="bg-slate-100 px-2 py-2 rounded-md">
                Entered Key value: {inputValue}
              </p>
              <br></br>
              <p>Hex Value: {hexInputValue}</p>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
                <svg
                  width="300"
                  height="38"
                  viewBox="0 0 573 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <motion.path
                    variants={icon}
                    initial="hidden"
                    animate="visible"
                    d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                    fill="black"
                  />
                </svg>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <div class="button-holder">
                  <div class="prev-button" onClick={firstpage}>
                    PREVIOUS
                  </div>
                  <div className="next-button" onClick={secondpage}>
                    NEXT
                  </div>
                </div>
              </div>
              <motion.div className="flex flex-col"
                variants={variantsFor56Bit}
                initial="hidden"
                animate="visible"
                >
                <p>56 Bit value</p>
                <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
                  {binaryInputValue56[0]}
                  <br></br>
                  {binaryInputValue56[1]}
                  <br></br>
                  {binaryInputValue56[2]}
                  <br></br>
                  {binaryInputValue56[3]}
                  <br></br>
                  {binaryInputValue56[4]}
                  <br></br>
                  {binaryInputValue56[5]}
                  <br></br>
                  {binaryInputValue56[6]}
                  <br></br>
                  {binaryInputValue56[7]}
                  <br></br>
                </div>
                
            </motion.div>
            <div className="flex flex-col">
              <img src={one} width="300" height="300" className="pl-10" />
              </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page1;